import { IconProps } from ".";
import Icon from "./assets/github_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Github(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
